import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';


import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('SIMPLE FORM DIALOG COMPONENT');

@Component({
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MaterialModule],
  selector: 'app-simple-form-dialog',
  templateUrl: './simple-form-dialog.component.html',
  styleUrls: ['./simple-form-dialog.component.scss']
})
export class SimpleFormDialogComponent implements OnInit {

  public formGroup: FormGroup;
  public inputs = [];
  public item = null;
  public service = null;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SimpleFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customMessageService: CustomMessageService
  ) { }

  ngOnInit(): void {
    this.inputs = this.data.inputs;
    this.item = this.data.item;
    this.service = this.data.service;
    let group = {};
    for (const input of this.inputs) {
      group[input['name']] = [this.data.type == 'update' ? this.item[input['name']] : null, input['required'] ? Validators.required : null];
    }
    this.formGroup = this.formBuilder.group(group)
  }


  /**@description Funcion para actualizar registro */
  async update(){
    try{
      if(!this.formGroup.valid){
        await this.customMessageService.open({title: 'Cuidado', type: 'warning', message: 'Es necesario completar todos los campos.', dismissBtn: true})
        return;
      }
      let data = this.formGroup.value;
      data['id'] = this.item['id'];
      this.customMessageService.open({title: 'Espere', type: 'success', message: `Guardando ${this.data.module}`, loading: true });
      let apiResponse = await this.service.update({operationType: 'one', data: data});
      this.customMessageService.close();
      if (apiResponse.state == 'success') {
        this.customMessageService.open({title: '¡Hecho!', type: 'success', message: apiResponse.message, duration: 2000 });
        this.dialogRef.close(apiResponse.data);
      }else{
        await this.customMessageService.open({title: 'Error', type: 'error', message: apiResponse.message, dismissBtn: true });
      }

    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

  /**@description Funcion para crear registro */
  async create(){
    try {
      if(!this.formGroup.valid){
        await this.customMessageService.open({title: 'Cuidado', type: 'warning', message: 'Es necesario completar todos los campos.', dismissBtn: true})
        return;
      }
      let data = this.formGroup.value;
      this.customMessageService.open({title: 'Espere', type: 'success', message: `Guardando ${this.data.module}`, loading: true });
      let apiResponse = await this.service.create({operationType: 'one', data: data});
      this.customMessageService.close();
      if (apiResponse.state == 'success') {
        this.customMessageService.open({title: '¡Hecho!', type: 'success', message: apiResponse.message, duration: 2000 });
        this.dialogRef.close(apiResponse.data);
      }else{
        await this.customMessageService.open({title: 'Error', type: 'error', message: apiResponse.message, dismissBtn: true });
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

}
